import { styled } from '@mui/material';

export const DeletedTime = styled('time')({
	fontSize: '10px',
	color: 'var(--text-secondary, #999)',
	paddingInline: '8px',
});
